var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.percentPrepayments.length)?_c('div',{staticClass:"product-prepayment"},[_c('text-icon',{attrs:{"iconName":"exclude"}},[_vm._v("\n        "+_vm._s(_vm.percentPrepayments)+" предоплата "),(_vm.visibleInstalment)?[_vm._v(" "+_vm._s(_vm.installmentPlanText)+" ")]:_vm._e()],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }